function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { transparentize } from 'polished';
import Button from '../Button';
/**
 * A ButtonGroup wraps as much Buttons as it is given as children.
 * Only one Button is active at a time. Each Button is cloned as is, meaning
 * you could provide Buttons with different styles.
 *
 * @return {jsx}
 */

var ButtonGroup = /*#__PURE__*/function (_PureComponent) {
  _inherits(ButtonGroup, _PureComponent);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup() {
    var _this;

    _classCallCheck(this, ButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeButton: _this.props.defaultActiveButtonName // eslint-disable-line react/destructuring-assignment

    });

    _defineProperty(_assertThisInitialized(_this), "updateActiveButton", function (name, onClick) {
      var onChange = _this.props.onChange;

      _this.setState({
        activeButton: name
      }, function () {
        onChange && onChange(name);
        onClick && onClick();
      });
    });

    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      var activeButton = this.state.activeButton;
      return /*#__PURE__*/React.createElement("div", {
        role: "group",
        className: className,
        tabIndex: "-1"
      }, Children.map(children, function (child) {
        if (child.props.disabled) {
          return child;
        }

        if (child.type.displayName !== 'Button') {
          return child;
        }

        if (!child.props.name) {
          throw new Error('"name" prop must be provided to Button');
        }

        return cloneElement(child, {
          onClick: function onClick() {
            return _this2.updateActiveButton(child.props.name, child.props.onClick);
          },
          'data-isactive': activeButton === child.props.name,
          'data-appearance': child.props.appearance
        });
      }));
    }
  }]);

  return ButtonGroup;
}(PureComponent);

var func = PropTypes.func,
    node = PropTypes.node,
    string = PropTypes.string;
/**
 * PropTypes Validation.
 */

ButtonGroup.propTypes = {
  /**
   * Anything that can be rendered: numbers, strings, elements or an array (or fragment)
   */
  children: node,

  /**
   * ClassName needed by styled components
   */
  className: string,

  /**
   * Specifies which button is initially selected
   */
  defaultActiveButtonName: string,

  /**
   * Callback function called when a button is clicked
   */
  onChange: func
};
/**
 * Default props.
 */

ButtonGroup.defaultProps = {
  children: null,
  className: '',
  defaultActiveButtonName: '',
  onChange: function onChange() {}
};
export default styled(ButtonGroup).withConfig({
  displayName: "ButtonGroup",
  componentId: "sc-133dx7y-0"
})(["display:flex;", "{border-radius:0;&:first-of-type{border-top-left-radius:", ";border-bottom-left-radius:", ";}&:nth-child(n):not(:first-of-type){border-left:0;}&:last-of-type{border-top-right-radius:", ";border-bottom-right-radius:", ";border-left:0;}&[data-isactive='true']{text-shadow:0.6px 0 0 currentColor;}&[data-isactive='true'][data-appearance='secondary']{color:", ";svg > path{fill:", ";}}&[data-isactive='false']{color:", ";svg > path{fill:", ";}}&[data-isactive='false'][data-appearance='secondary'],&[data-isactive='false'][data-appearance='default']{color:", ";svg > path{fill:", ";}}}"], Button, function (_ref) {
  var dimensions = _ref.theme.dimensions;
  return dimensions.radius;
}, function (_ref2) {
  var dimensions = _ref2.theme.dimensions;
  return dimensions.radius;
}, function (_ref3) {
  var dimensions = _ref3.theme.dimensions;
  return dimensions.radius;
}, function (_ref4) {
  var dimensions = _ref4.theme.dimensions;
  return dimensions.radius;
}, function (_ref5) {
  var palette = _ref5.theme.palette;
  return palette.primary["default"];
}, function (_ref6) {
  var palette = _ref6.theme.palette;
  return transparentize(0.3, palette.primary["default"]);
}, function (_ref7) {
  var palette = _ref7.theme.palette;
  return transparentize(0.3, palette.white);
}, function (_ref8) {
  var palette = _ref8.theme.palette;
  return transparentize(0.3, palette.white);
}, function (_ref9) {
  var palette = _ref9.theme.palette;
  return transparentize(0.1, palette.spaceGrey);
}, function (_ref10) {
  var palette = _ref10.theme.palette;
  return transparentize(0.3, palette.spaceGrey);
});